export const softwareList = [
  {
    id: 1,
    name: 'WPS Office',
    icon: 'ri-file-word-2-line',
    category: '办公软件',
    size: '245MB',
    rating: 4.8,
    downloads: '1,280万',
    version: '2024 专业版',
    description: '国产办公套件，兼容Word/Excel/PPT格式，支持云端协作与AI智能写作',
    tags: ['办公', '免费', '推荐'],
    featured: true,
    isNew: false,
  },
  {
    id: 2,
    name: '剪映专业版',
    icon: 'ri-film-line',
    category: '多媒体',
    size: '680MB',
    rating: 4.9,
    downloads: '2,560万',
    version: 'v6.8.0',
    description: '全能视频剪辑工具，支持AI字幕生成、智能抠像、海量模板素材',
    tags: ['视频剪辑', '免费', 'AI'],
    featured: true,
    isNew: false,
  },
  {
    id: 3,
    name: '网易云音乐',
    icon: 'ri-music-line',
    category: '影音娱乐',
    size: '128MB',
    rating: 4.7,
    downloads: '8,900万',
    version: 'v9.2.0',
    description: '高品质音乐播放器，海量正版曲库，智能推荐与社交评论功能',
    tags: ['音乐', '推荐', '热门'],
    featured: true,
    isNew: false,
  },
  {
    id: 4,
    name: '腾讯会议',
    icon: 'ri-vidicon-line',
    category: '办公软件',
    size: '156MB',
    rating: 4.6,
    downloads: '5,320万',
    version: 'v4.8.5',
    description: '专业视频会议工具，支持千人同时在线，屏幕共享、虚拟背景',
    tags: ['会议', '办公', '免费'],
    featured: false,
    isNew: false,
  },
  {
    id: 5,
    name: '百度网盘',
    icon: 'ri-hard-drive-2-line',
    category: '实用工具',
    size: '98MB',
    rating: 4.5,
    downloads: '12,800万',
    version: 'v8.2.0',
    description: '大容量云存储服务，文件同步备份，在线解压预览，极速传输',
    tags: ['网盘', '存储', '热门'],
    featured: true,
    isNew: false,
  },
  {
    id: 6,
    name: '原神',
    icon: 'ri-gamepad-line',
    category: '游戏',
    size: '42.5GB',
    rating: 4.9,
    downloads: '6,780万',
    version: 'v5.2',
    description: '开放世界冒险游戏，精美的二次元画风，七国探索与角色养成',
    tags: ['游戏', '热门', '推荐'],
    featured: true,
    isNew: false,
  },
  {
    id: 7,
    name: '微信',
    icon: 'ri-wechat-line',
    category: '社交沟通',
    size: '325MB',
    rating: 4.8,
    downloads: '35,600万',
    version: 'v4.0.8',
    description: '全能社交应用，即时通讯、朋友圈、公众号、小程序一站式服务',
    tags: ['社交', '必备', '推荐'],
    featured: true,
    isNew: false,
  },
  {
    id: 8,
    name: 'Everything',
    icon: 'ri-search-eye-line',
    category: '实用工具',
    size: '3.2MB',
    rating: 4.9,
    downloads: '3,450万',
    version: 'v1.5.0',
    description: '极速文件搜索工具，毫秒级检索硬盘所有文件，轻量高效',
    tags: ['搜索', '效率', '免费'],
    featured: false,
    isNew: false,
  },
  {
    id: 9,
    name: 'Visual Studio Code',
    icon: 'ri-code-s-slash-line',
    category: '开发工具',
    size: '186MB',
    rating: 4.8,
    downloads: '4,210万',
    version: 'v1.98',
    description: '微软开源代码编辑器，丰富插件生态，智能代码补全与调试',
    tags: ['编程', '开源', '推荐'],
    featured: true,
    isNew: false,
  },
  {
    id: 10,
    name: '迅雷X',
    icon: 'ri-download-2-line',
    category: '实用工具',
    size: '72MB',
    rating: 4.4,
    downloads: '18,900万',
    version: 'v12.0.8',
    description: '高速下载引擎，支持BT/磁力链接/ed2k多协议，边下边播',
    tags: ['下载', '热门', '必备'],
    featured: false,
    isNew: false,
  },
  {
    id: 11,
    name: 'Steam',
    icon: 'ri-steam-line',
    category: '游戏',
    size: '185MB',
    rating: 4.8,
    downloads: '7,650万',
    version: 'v3.2.0',
    description: '全球最大PC游戏平台，海量正版游戏库，社区工坊与云存档',
    tags: ['游戏平台', '必备', '推荐'],
    featured: false,
    isNew: false,
  },
  {
    id: 12,
    name: '阿里云盘',
    icon: 'ri-cloud-line',
    category: '实用工具',
    size: '115MB',
    rating: 4.6,
    downloads: '4,880万',
    version: 'v5.8.0',
    description: '不限速云存储，超大免费空间，文件秒传与智能分类管理',
    tags: ['网盘', '不限速', '热门'],
    featured: false,
    isNew: true,
  },
  {
    id: 13,
    name: 'Adobe Photoshop',
    icon: 'ri-image-edit-line',
    category: '多媒体',
    size: '3.8GB',
    rating: 4.9,
    downloads: '5,120万',
    version: '2024 v25.0',
    description: '专业图像处理软件，AI生成填充，图层管理，摄影师必备工具',
    tags: ['设计', '图像', '专业'],
    featured: false,
    isNew: false,
  },
  {
    id: 14,
    name: '7-Zip',
    icon: 'ri-file-zip-line',
    category: '实用工具',
    size: '1.5MB',
    rating: 4.7,
    downloads: '9,320万',
    version: 'v24.08',
    description: '开源压缩解压工具，支持7z/ZIP/RAR等格式，高压缩比',
    tags: ['压缩', '开源', '免费'],
    featured: false,
    isNew: false,
  },
  {
    id: 15,
    name: 'OBS Studio',
    icon: 'ri-live-line',
    category: '多媒体',
    size: '248MB',
    rating: 4.7,
    downloads: '2,860万',
    version: 'v31.0',
    description: '开源直播推流与录屏软件，多场景切换，虚拟摄像头与滤镜',
    tags: ['直播', '录屏', '开源'],
    featured: false,
    isNew: true,
  },
  {
    id: 16,
    name: 'QQ',
    icon: 'ri-qq-line',
    category: '社交沟通',
    size: '285MB',
    rating: 4.5,
    downloads: '28,500万',
    version: 'v9.9.20',
    description: '经典即时通讯工具，文件传输、远程协助、QQ空间一站式服务',
    tags: ['社交', '经典', '必备'],
    featured: false,
    isNew: false,
  },
  {
    id: 17,
    name: 'Notion',
    icon: 'ri-sticky-note-line',
    category: '办公软件',
    size: '165MB',
    rating: 4.8,
    downloads: '1,860万',
    version: 'v3.8.0',
    description: '全能笔记与知识管理工具，数据库视图、团队协作、AI助手',
    tags: ['笔记', '协作', 'AI'],
    featured: false,
    isNew: true,
  },
  {
    id: 18,
    name: 'Chrome浏览器',
    icon: 'ri-chrome-line',
    category: '浏览器',
    size: '132MB',
    rating: 4.8,
    downloads: '32,000万',
    version: 'v130.0',
    description: '谷歌出品高速浏览器，强大扩展生态，跨设备同步与隐私保护',
    tags: ['浏览器', '必备', '推荐'],
    featured: true,
    isNew: false,
  },
  {
    id: 19,
    name: '火绒安全',
    icon: 'ri-shield-check-line',
    category: '安全防护',
    size: '45MB',
    rating: 4.7,
    downloads: '4,560万',
    version: 'v6.0.2',
    description: '轻量级杀毒软件，弹窗拦截、漏洞修复，安静守护电脑安全',
    tags: ['杀毒', '免费', '推荐'],
    featured: false,
    isNew: false,
  },
  {
    id: 20,
    name: 'PotPlayer',
    icon: 'ri-play-circle-line',
    category: '影音娱乐',
    size: '42MB',
    rating: 4.8,
    downloads: '6,120万',
    version: 'v1.7.22230',
    description: '全能视频播放器，硬解加速、字幕支持、3D播放与皮肤美化',
    tags: ['播放器', '免费', '热门'],
    featured: false,
    isNew: false,
  },
  {
    id: 21,
    name: '钉钉',
    icon: 'ri-briefcase-line',
    category: '办公软件',
    size: '210MB',
    rating: 4.4,
    downloads: '11,200万',
    version: 'v7.6.0',
    description: '企业数字化办公平台，即时通讯、视频会议、OA审批一体化',
    tags: ['办公', '企业', '常用'],
    featured: false,
    isNew: false,
  },
  {
    id: 22,
    name: '英雄联盟',
    icon: 'ri-sword-line',
    category: '游戏',
    size: '28GB',
    rating: 4.7,
    downloads: '15,800万',
    version: 'v14.22',
    description: '经典MOBA竞技游戏，5v5团队对战，全球最受欢迎电竞项目',
    tags: ['游戏', '电竞', '热门'],
    featured: false,
    isNew: false,
  },
  {
    id: 23,
    name: 'Typora',
    icon: 'ri-markdown-line',
    category: '办公软件',
    size: '82MB',
    rating: 4.8,
    downloads: '1,230万',
    version: 'v1.9.5',
    description: '所见即所得Markdown编辑器，数学公式、流程图、导出多格式',
    tags: ['写作', '效率', '推荐'],
    featured: false,
    isNew: true,
  },
  {
    id: 24,
    name: 'Edge浏览器',
    icon: 'ri-edge-line',
    category: '浏览器',
    size: '148MB',
    rating: 4.6,
    downloads: '20,500万',
    version: 'v130.0',
    description: '微软AI浏览器，Copilot智能助手、垂直标签页、集锦收藏',
    tags: ['浏览器', 'AI', '推荐'],
    featured: false,
    isNew: false,
  },
];

export const softwareCategories = [
  '全部',
  '办公软件',
  '多媒体',
  '游戏',
  '实用工具',
  '影音娱乐',
  '社交沟通',
  '开发工具',
  '浏览器',
  '安全防护',
];

export const stats = [
  { icon: 'ri-download-cloud-2-line', value: '98亿+', label: '累计下载次数' },
  { icon: 'ri-shield-check-line', value: '100%', label: '安全检测通过率' },
  { icon: 'ri-apps-line', value: '50,000+', label: '收录软件数量' },
  { icon: 'ri-user-smile-line', value: '3,200万+', label: '活跃用户' },
];